import React, { useEffect, useState } from 'react';

interface OperationStatusProps {
  description: string;
  percent: number;
  subtask: string;
}

const Spinner = () => (
  <svg
    className="animate-spin"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10"
      strokeLinecap="round"
      style={{ stroke: '#4A90E2' }}
    />
  </svg>
);

const OperationStatusComponent: React.FC<OperationStatusProps> = ({
  description,
  percent,
  subtask,
}) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 1) % 360);
    }, 16);
    return () => clearInterval(interval);
  }, []);

  // Custom background gradient using brand colors
  const backgroundGradient = `conic-gradient(from ${rotation}deg, 
    #4A90E2 0deg, 
    #FF6B6B 120deg,
    #4A90E2 240deg,
    #4A90E2 360deg)`;

  return (
    <div className="relative w-96 h-96 flex flex-col items-center justify-center rounded-lg shadow-lg overflow-hidden z-10"
      style={{ background: 'linear-gradient(135deg, rgba(74,144,226,0.9), rgba(255,107,107,0.9))' }}>
      {/* Background animated rings */}
      <div
        className="absolute w-full h-full opacity-10"
        style={{ background: backgroundGradient }}
      />

      {/* Rotating outer circle */}
      <div
        className="absolute w-64 h-64 rounded-full border-4 border-transparent"
        style={{
          transform: `rotate(${rotation}deg)`,
          borderTopColor: '#4A90E2',
          borderRightColor: '#FF6B6B'
        }}
      />

      {/* Inner content container */}
      <div className="relative z-10 flex flex-col items-center gap-4 p-8 rounded-full bg-white/90 w-48 h-48 justify-center">
        {/* Custom spinner component */}
        <Spinner />

        {/* Percentage */}
        <div
          className="text-2xl font-bold"
          style={{
            background: 'linear-gradient(90deg, #4A90E2, #FF6B6B)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          {percent}%
        </div>
      </div>

      {/* Text content */}
      <div className="absolute bottom-3 flex flex-col items-center gap-2 px-8 text-center">
        <h2 className="text-xl font-semibold" style={{ color: 'white' }}>
          {description}
        </h2>
        <p className="text-sm" style={{ color: 'white' }}>
          {subtask}
        </p>
      </div>
    </div>
  );
};

export default OperationStatusComponent;